import React, { useState, useEffect } from "react";
import {
  Input,
  DatePicker,
  Radio
} from "antd";
import ReportApi from "@api/report";
import Title from "@/components/Title";
import moment from "moment";
import Area from "@/components/twoarea";
import Analysisapi from "@/api/analysis";
import Charts from "./echart.js";
import Ocharts from "./ochart.js";
import "./../style.scss";
import "./style.css";
const { RangePicker } = DatePicker;

export default ({ history }) => {
  const date = new Date();
  const Year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  var clock = Year + "-";
  var clock1 = Year + "-";
  if (month < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += month + "-";
  clock1 += month + "-";
  if (day < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += day + " ";
  clock1 += day + 1 + " ";
  const [data, setData] = useState([]);
  const [InandOutData, setInandOutData] = useState({});
  const [station, setStation] = useState([]);
  const [stationId, setStationId] = useState();
  const [totalWater, setTotalWater] = useState("");
  const [bigStation, setBigStation] = useState("");
  const [bigLoadRate, setBigLoadRate] = useState("");
  const [defaultDate, setDefaultDate] = useState();
  const [defaultTwoDate, setDefaultTwoDate] = useState();
  let total = 0;
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    queryTimeStartStr: moment().format("YYYY-MM-DD") + " 00:00:00",
    queryTimeEndStr: moment().add(1, 'days').format("YYYY-MM-DD") + " 23:59:59",
    reportType: 1,
    inOrOut: 2,
    type: 5,
  });
  const [twoSearchParams, setTwoSearchParams] = useState({
    queryTimeStartStr: moment().format("YYYY-MM-DD") + " 00:00:00",
    queryTimeEndStr: moment().add(1, 'days').format("YYYY-MM-DD") + " 23:59:59",
    reportType: 1,
    inOrOut: 4,
    type: 5,
    stationId: stationId,
  });

  useEffect(() => {
    findTotalWater();
  }, [searchParams]);

  useEffect(() => {
    if (stationId) {
      findInAndOutWater();
    }
  }, [twoSearchParams]);

  useEffect(() => {
    getStation();
  }, []);
  const getStation = (params) => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
        const id = res.data[0] ? res.data[0].id : null;
        setStationId(id);
        setTwoSearchParams({ ...twoSearchParams, stationId: id });
      }
    });
  };
  const getStationId = (id) => {
    setTwoSearchParams({
      ...twoSearchParams,
      stationId: id,
    });
    setStationId(id);
  };

  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  const stationIds = userInfo.stationIds ? userInfo.stationIds.split(",") : [];
  //总出水量分析
  const findTotalWater = () => {
    let data = {
      ...searchParams,
      dutyUserStationIds: stationIds,
      queryTimeStartStr: searchParams.queryTimeStartStr
        ? searchParams.queryTimeStartStr.split(" ")[0] + " 09:00:00"
        : "",
      queryTimeEndStr: searchParams.queryTimeEndStr
        ? searchParams.queryTimeEndStr.split(" ")[0] + " 09:00:00"
        : "",
    };
    ReportApi.totalWater(data).then((res) => {
      if (res.status == 0 && res.data.length >= 1) {
        let max = res.data[0].totalYield;
        let station = res.data[0].stationName;
        let bigLoadRateStation = res.data[0].stationName;
        let loadRate = res.data[0].totalYield / res.data[0].dayDesignProc;
        setData(res.data);
        res.data.map((item, index) => {
          total += item.totalYield;
          setTotalWater(total.toFixed(2));
          res.data[index].totalYield > max
            ? ((max = res.data[index].totalYield),
              (station = res.data[index].stationAliasName))
            : null;
          setBigStation(station);
          res.data[index].totalYield / res.data[index].dayDesignProc > loadRate
            ? ((loadRate =
                res.data[index].totalYield / res.data[index].dayDesignProc),
              (bigLoadRateStation = res.data[index].stationAliasName))
            : "";
          setBigLoadRate(bigLoadRateStation);
        });
      } else {
        setData([]);
        setTotalWater(0);
        setBigStation();
        setBigLoadRate();
      }
    });
  };
  const DateQuery = (obj, tag) => {
    if (tag == 1) {
      setDefaultDate(obj);
      const startTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const endTime = moment(obj[1]).format("YYYY-MM-DD") + " 00:00:00";
      setSearchParams({
        ...searchParams,
        queryTimeStartStr: startTime,
        queryTimeEndStr: endTime,
      });
    }
    if (tag == 2) {
      setDefaultTwoDate(obj);
      const astartTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const aendTime = moment(obj[1]).format("YYYY-MM-DD") + " 00:00:00";
      setTwoSearchParams({
        ...twoSearchParams,
        queryTimeStartStr: astartTime,
        queryTimeEndStr: aendTime,
      });
    }
  };
  const slotQuery = (obj, tag) => {
    let firstDate = "";
    let endDate = "";
    if (month < 10) {
      firstDate = Year + "-" + "0" + month + "-01";
    } else {
      firstDate = Year + "-" + month + "-01";
    }
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let lastTime = new Date(nextMonthFirstDay - oneDay);
    let cmonth = parseInt(lastTime.getMonth() + 1);
    let cday = lastTime.getDate();
    if (cmonth < 10) {
      cmonth = "0" + cmonth;
    }
    if (cday < 10) {
      cday = "0" + cday;
    }
    endDate = date.getFullYear() + "-" + cmonth + "-" + cday;
    const bstartTime = moment(firstDate).format("YYYY-MM-DD") + " 00:00:00";
    const bendTime = moment(endDate).format("YYYY-MM-DD") + " 23:59:59";

    let firstDay = new Date();
    firstDay.setDate(1);
    firstDay.setMonth(0);
    let lastDay = new Date();
    lastDay.setFullYear(lastDay.getFullYear() + 1);
    lastDay.setDate(31);
    lastDay.setMonth(-1);
    firstDay = moment(firstDay).format("YYYY-MM-DD") + " 00:00:00";
    lastDay = moment(lastDay).format("YYYY-MM-DD") + " 23:59:59";

    if (tag == 1) {
      setDefaultDate(null);
      if (obj.target.value == "day") {
        setSearchParams({
          ...searchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
    if (tag == 2) {
      setDefaultTwoDate(null);
      if (obj.target.value == "day") {
        setTwoSearchParams({
          ...twoSearchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setTwoSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setTwoSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
  };
  //进出水量分析
  const findInAndOutWater = () => {
    let data = { ...twoSearchParams, stationId: stationId };
    if (data.reportType == 1) {
      data.queryTimeEndStr =
        moment(new Date()).format("YYYY-MM-DD ") + "23:59:59";
    }
    ReportApi.InAndOutWater(data).then((res) => {
      if (res.status == 0 && res.data) {
        setInandOutData(res.data);
      }
    });
  };

  // console.log('chart', option)
  return (
    <div className="baseContent quantity">
      <div className="column" style={{ position: "relative" }}>
        <Title title="总出水量分析"></Title>
        <div className="columns">
          <div className="scolumns">
            <p>总处理规模</p>
            <div>{totalWater}吨</div>
          </div>
          <div className="scolumns">
            <p>处理量最大厂站</p>
            <div>{bigStation}</div>
          </div>
          <div className="scolumns">
            <p>负载率最大厂站</p>
            <div>{bigLoadRate}</div>
          </div>
        </div>
        <div className="date">
          <span>
            时间：
            <RangePicker
              value={defaultDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 1);
              }}
              style={{ width: "220px" }}
            />
          </span>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 1);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        <Charts data={data} />
      </div>

      <div className="column" style={{ position: "relative" }}>
        <Title title="进出水量分析"></Title>
        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={getStationId} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={defaultTwoDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 2);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 2);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        <Ocharts InandOutData={InandOutData} stationId={stationId} />
      </div>
    </div>
  );
};
